<template>
  <div class="orders-filter" v-if="params">
    <div class="orders-filter__top">
      <div class="orders-filers">
        <Select2
          class="mr-12"
          v-model="params.service_id"
          :settings="selectSettings.services"
          :options="services"
          @change="filter"
        />

        <Select2
          :options="[
            {
              id: 'all',
              text: $t('listsHeader.all'),
            },
            {
              id: 'admin-panel',
              text: 'Admin',
            },
            {
              id: 'mobile-app-android',
              text: 'Android',
            },
            {
              id: 'mobile-app-ios',
              text: 'iOS',
            },
            {
              id: 'web-app',
              text: 'Web',
            },
            {
              id: 'landing-page',
              text: 'Landing',
            },
            {
              id: 'my-hammer',
              text: 'MyHammer',
            },
          ]"
          :settings="{
            placeholder: $t('forms.source'),
          }"
          v-model="params.source"
          @change="filter"
          class="mr-12"
        />

        <Select2
          :options="[
            { id: 'all', text: $t('listsHeader.all') },
            { id: 'new', text: $t('ordersStatus.new') },
            { id: 'stand_by', text: $t('ordersStatus.stand_by') },
            { id: 'confirmed', text: $t('ordersStatus.confirmed') },
            {
              id: 'master_on_the_way',
              text: $t('ordersStatus.master_on_the_way'),
            },
            { id: 'master_arrived', text: $t('ordersStatus.master_arrived') },
            { id: 'job_started', text: $t('ordersStatus.job_started') },
            { id: 'job_finished', text: $t('ordersStatus.job_finished') },
            { id: 'payment', text: $t('ordersStatus.payment') },
            { id: 'rating_review', text: $t('ordersStatus.rating_review') },
            { id: 'closed', text: $t('ordersStatus.closed') },
            { id: 'canceled', text: $t('ordersStatus.canceled') },
          ]"
          v-model="params.status"
          :settings="selectSettings.statuses"
          @change="filter"
          class="mr-12"
        />

        <Select2
          :options="[
            { id: 'all', text: $t('listsHeader.all') },
            { id: true, text: $t('listsHeader.paid') },
            { id: false, text: $t('listsHeader.notPaid') },
          ]"
          v-model="params.isPaid"
          :settings="selectSettings.paid"
          @change="filter"
          class="mr-12"
        />

        <Select2
          :options="[
            {
              id: 'all',
              text: $t('listsHeader.all'),
            },
            {
              id: '1',
              text: '1',
            },
            {
              id: '2',
              text: '2',
            },
            {
              id: '3',
              text: '3',
            },
            {
              id: '4',
              text: '4',
            },
            {
              id: '5',
              text: '5',
            },
          ]"
          :settings="{
            placeholder: $t('forms.company'),
          }"
          v-model="params.companyRating"
          @change="filter"
          class="mr-12"
        />

        <Select2
          class="mr-12"
          :options="[
            {
              id: 'all',
              text: $t('listsHeader.all'),
            },
            {
              id: '1',
              text: '1',
            },
            {
              id: '2',
              text: '2',
            },
            {
              id: '3',
              text: '3',
            },
            {
              id: '4',
              text: '4',
            },
            {
              id: '5',
              text: '5',
            },
          ]"
          :settings="{
            placeholder: $t('forms.master'),
          }"
          v-model="params.masterRating"
          @change="filter"
        />

        <Select2
          class="mr-12"
          :options="[
            {
              id: 'all',
              text: $t('listsHeader.all'),
            },
            {
              id: 'undefined',
              text: $t('ordersStatus.not_selected'),
            },
            {
              id: 'cash',
              text: $t('ordersStatus.cash'),
            },
            {
              id: 'bill',
              text: $t('ordersStatus.bill'),
            },
          ]"
          :settings="{
            placeholder: $t('ordersStatus.payment'),
          }"
          v-model="params.paymentType"
          @change="filter"
        />

        <Select2
          v-if="filteredList"
          :options="filteredList"
          :settings="{
            placeholder: $t('forms.default'),
            allowClear: false,
          }"
          v-model="params.office_id"
          class="select mr-12"
          @select="filter"
        />

        <button
          @click="clearAll"
          class="main-button main-button_cancel main-button_w160 mr-12"
        >Filter löschen</button>

        <button class="main-button main-button_green main-button_w70" @click="downloadPdf">
          <svg
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            xml:space="preserve"
            width="20px"
            height="20px"
          >
            <g>
              <g>
                <path
                  d="M282.208,19.67c-3.648-3.008-8.48-4.256-13.152-3.392l-256,48C5.472,65.686,0,72.278,0,79.99v352
			c0,7.68,5.472,14.304,13.056,15.712l256,48c0.96,0.192,1.984,0.288,2.944,0.288c3.68,0,7.328-1.28,10.208-3.68
			c3.68-3.04,5.792-7.584,5.792-12.32v-448C288,27.222,285.888,22.71,282.208,19.67z M256,460.694L32,418.71V93.27l224-41.984
			V460.694z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M496,79.99H272c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h208v288H272c-8.832,0-16,7.168-16,16
			c0,8.832,7.168,16,16,16h224c8.832,0,16-7.168,16-16v-320C512,87.158,504.832,79.99,496,79.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M336,143.99h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16
			C352,151.158,344.832,143.99,336,143.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M336,207.99h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16
			C352,215.158,344.832,207.99,336,207.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M336,271.99h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16
			C352,279.158,344.832,271.99,336,271.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M336,335.99h-64c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16
			C352,343.158,344.832,335.99,336,335.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M432,143.99h-32c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h32c8.832,0,16-7.168,16-16
			C448,151.158,440.832,143.99,432,143.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M432,207.99h-32c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h32c8.832,0,16-7.168,16-16
			C448,215.158,440.832,207.99,432,207.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M432,271.99h-32c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h32c8.832,0,16-7.168,16-16
			C448,279.158,440.832,271.99,432,271.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M432,335.99h-32c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h32c8.832,0,16-7.168,16-16
			C448,343.158,440.832,335.99,432,335.99z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M220.064,309.462l-112-128c-5.888-6.688-15.968-7.328-22.592-1.504c-6.656,5.824-7.328,15.936-1.504,22.56l112,128
			c3.168,3.616,7.584,5.472,12.032,5.472c3.744,0,7.488-1.312,10.56-3.968C225.216,326.198,225.888,316.118,220.064,309.462z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M217.824,163.382c-6.976-5.472-17.024-4.16-22.464,2.784l-112,144c-5.408,6.976-4.16,17.056,2.816,22.464
			c2.944,2.272,6.4,3.36,9.824,3.36c4.736,0,9.472-2.112,12.608-6.144l112-144C226.048,178.838,224.8,168.79,217.824,163.382z"
                />
              </g>
            </g>
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
          </svg>
        </button>
      </div>
    </div>

    <div class="orders-filter__bottom">
      <div class="orders-filers">
        <el-input-number
          :placeholder="`${$t('listsHeader.price')} min`"
          v-model="params.priceFrom"
          controls-position="right"
          @change="filter"
          :min="0"
          class="mr-12 main-form__input main-form__input_number main-form__input_h36 main-form__input_w130"
        ></el-input-number>

        <el-input-number
          :placeholder="`${$t('listsHeader.price')} max`"
          v-model="params.priceTill"
          controls-position="right"
          @change="filter"
          class="mr-12 main-form__input main-form__input_number main-form__input_h36 main-form__input_w130"
        ></el-input-number>

        <datetime
          class="mr-12 vdatetime_w160"
          type="date"
          v-model="dateFrom"
          input-class="date-input"
          :phrases="{
            ok: $t('request.continue'),
            cancel: $t('request.exit'),
          }"
          :placeholder="$t('request.dateHolder')"
          @input="dateChange"
        />
        <datetime
          class="mr-12 vdatetime_w160"
          type="date"
          v-model="dateTill"
          input-class="date-input"
          :phrases="{
            ok: $t('request.continue'),
            cancel: $t('request.exit'),
          }"
          :placeholder="$t('request.dateHolder')"
          @input="dateChange"
        />

        <input
          type="text"
          class="mr-12 main-form__input main-form__input_h36 main-form__input_w150"
          :placeholder="$t('forms.predictedFor')"
          v-model="params.predictedTimeFrom"
          @change="filter"
        />
        <input
          type="text"
          class="mr-12 main-form__input main-form__input_h36 main-form__input_w150"
          :placeholder="$t('forms.predictedTill')"
          v-model="params.predictedTimeTill"
          @change="filter"
        />

        <input
          min="0"
          type="number"
          class="mr-12 main-form__input main-form__input_h36 main-form__input_w150"
          v-model="params.spentFrom"
          @change="filter"
          :placeholder="$t('forms.spentFrom')"
        />
        <input
          min="0"
          type="number"
          class="mr-12 main-form__input main-form__input_h36 main-form__input_w150"
          v-model="params.spentTo"
          @change="filter"
          :placeholder="$t('forms.spentTo')"
        />

        <Select2
          class="mr-12"
          v-model="params.created_at"
          :settings="{
            placeholder: $t('controls.month'),
          }"
          :options="sortedMonth"
          @change="filter"
        />

        <div class="orders-filter__search orders-filter_width">
          <search @searchData="search" :value="params.search" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import sortedMonth from '@/utils/sortedMonth'

export default {
    name: 'orders-filter',
    data() {
        return {
            partners: null,
            sortedMonth,
        }
    },
    computed: {
        ...mapGetters({
            params: 'orders/paramsGetters',
            selectSettings: 'orders/selectSettingsGetters',
            services: 'servicesGettersWithAll',
            partnersRaw: 'partners/partnersGetters',
            filteredList: 'offices/filteredListAll',
        }),
        dateFrom: {
            get() {
                return this.params.shouldStartedFrom.value
            },
            set(v) {
                this.params.shouldStartedFrom.value = v
                this.params.shouldStartedFrom.time = new Date(v).getTime()
            },
        },
        dateTill: {
            get() {
                return this.params.shouldStartedTill.value
            },
            set(v) {
                this.params.shouldStartedTill.value = v
                this.params.shouldStartedTill.time = new Date(v).getTime()
            },
        },
    },
    methods: {
        ...mapMutations({
            setParams: 'orders/setParams',
            setParamByKey: 'orders/setParamByKey',
            clearParams: 'orders/clearParams',
        }),
        ...mapActions({
            fetch: 'orders/fetch',
            getServices: 'getServices',
            fetchPartners: 'partners/fetch',
            generatePdf: 'orders/generatePdf',
            fetchMinMaxPrice: 'orders/fetchMinMaxPrice',
        }),
        downloadPdf() {
            this.generatePdf()
        },
        async filter() {
            this.setParams(this.params)
            await this.fetch({ page: 1, isFilter: true })
        },
        async search(v) {
            this.params.search = v
            await this.fetch({ page: 1, isFilter: true })
        },
        dateChange() {
            if (this.dateFrom !== '') {
                this.filter()
            }

            if (this.dateTill !== '') {
                this.filter()
            }
        },
        async clearAll() {
            this.params.search = ''
            this.clearParams()
            await this.fetchMinMaxPrice()
            this.filter()
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.orders-filter__input_green::-webkit-input-placeholder {
  color: #61422d;
}

.orders-filers {
  display: flex;
  max-width: 100%;
}

.orders-filter {
  width: calc(100% - 25px);
  display: flex;
  flex-direction: column;

  &__search {
    max-width: 240px;
  }

  &__price,
  &__arrival-time {
    display: flex;
  }

  &__price {
    align-items: center;

    &_start {
      align-items: flex-start;
    }
  }

  &__top {
    width: inherit;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 15px;
  }

  &__bottom {
    width: inherit;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  &__date {
    display: flex;
    justify-content: space-between;
  }

  &_mr {
    margin-right: 45px !important;
  }

  &__input {
    border-radius: 8px;
    // background-color: #ffffff;
    // border: 1px solid #e0e0e0;
    // font-family: "SFUIDisplay-Regular";
    // font-size: 14px;
    // color: #61422d;
    // padding-left: 13px;
    // -webkit-box-sizing: border-box;
    // box-sizing: border-box;
    // -webkit-transition: 0.5s;
    // transition: 0.5s;
    // margin-top: 5px;
    // outline: none;
    // overflow: hidden;
    // height: 100%;
    // display: flex;
    // align-items: center;
    // width: 120px !important;

    // &:not(:last-child) {
    //   margin-right: 15px;
    // }

    // &:not(:first-child) {
    //   margin-left: 5px;
    // }

    // &_baseHeight {
    //   height: 40px;
    // }
  }
}
</style>

<style>
body .select2-container {
  min-width: 150px !important;
  width: 100% !important;
  max-width: 100%;
}

.orders-filter__price .el-input-number {
  height: 40px !important;
  max-width: 130px;
  margin-right: 15px !important;
}

.orders-filter__price .el-input__prefix {
  display: none !important;
}

.orders-filter__price .el-date-editor--time-select {
  padding-left: 0 !important;
}

.orders-filter__price .el-input__inner:hover {
  border-color: transparent !important;
}

.orders-filter__price .time-select-item {
  padding-left: 30px !important;
}

.orders-filter__search .search {
  max-width: 190px !important;
}

.vdatetime_w160 {
  max-width: 160px !important;
  min-width: 160px !important;
  width: 160px !important;
}
</style>
